export const onNewEventifyEvent = () => {
    window.open('/eventify/newEvent', '_blank');
};
